import React, { useState, useEffect } from "react";
import Info from "../../InputSign/Info";

import { Container, Message, InputMaskInput } from "./styles";

const Input = (props) => {
  const [windowWidth, setWindowWidth] = useState(1000);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });
  }, []);

  return (
    <Container disabled={props?.disabled}>
      {windowWidth > 900 ? (
        <fieldset>
          <legend>
            <span>{props.title}</span>
            {props.value.info && <Info inline value={props.value.info} />}
          </legend>
          {props.type === "number" ? (
            <input
              disabled={props?.disabled}
              placeholder={props.placeholder}
              value={props.value.value}
              type={props.type}
              onChange={(e) =>
                props.setValue({
                  ...props.value,
                  value: parseInt(e.target.value),
                  message: props.validate(parseInt(e.target.value)),
                })
              }
            />
          ) : (
            <InputMaskInput
              disabled={props?.disabled}
              mask={props.mask}
              placeholder={props.placeholder}
              value={props.value.value}
              type={props.type}
              onChange={(e) =>
                props.setValue({
                  ...props.value,
                  value: e.target.value,
                  message: props.validate(e.target.value),
                })
              }
            />
          )}
        </fieldset>
      ) : (
        <main>
          <legend>
            <span>{props.title}</span>
            {props.value.info && <Info inline value={props.value.info} />}
          </legend>
          {props.type === "number" ? (
            <input
              disabled={props?.disabled}
              placeholder={props.placeholder}
              value={props.value.value}
              type={props.type}
              onChange={(e) =>
                props.setValue({
                  ...props.value,
                  value: parseInt(e.target.value),
                  message: props.validate(parseInt(e.target.value)),
                })
              }
            />
          ) : (
            <InputMaskInput
              disabled={props?.disabled}
              mask={props.mask}
              placeholder={props.placeholder}
              value={props.value.value}
              type={props.type}
              onChange={(e) =>
                props.setValue({
                  ...props.value,
                  value: e.target.value,
                  message: props.validate(e.target.value),
                })
              }
            />
          )}
        </main>
      )}
      <Message> {!props.disabled && props.value.message}</Message>
    </Container>
  );
};

export default Input;
